<div class="filter-container">
    <div class="filter-sort">
        <button *ngIf="showFilter" class="filter" [sch-filter-trigger]="filterMenu">
            <i sch-icon="filter-outline"></i>
            <span *ngIf="showLabel"> Filter</span>

        </button>

        <button *ngIf="showSort" sch-button variant="outline" class="sort">
            <i sch-icon="sort"></i>
            <span *ngIf="showLabel"> Sort</span>
        </button>
    </div>

</div>

<ng-template #filterMenu>
    <div *ngIf="options.length > 0" class="filter-menu" #filterMenuContainer>
        <div class="add-filter-reset">
            <button class="add-filter">Add Filter</button>
            <button class="reset"> <i sch-icon="replay"></i> Reset</button>
        </div>

        <div class="filter-options">
            <ng-container *ngFor="let option of options">
                @switch (option.type) {
                @case ('date-range') {
                <div class="filter-option" [sch-filter-trigger]="dateRange" [anchorTo]="filterMenuContainer"
                    fallbackStrategy="horizontal">
                    <i *ngIf="option.icon" [sch-icon]="option.icon"></i>
                    <span>{{option.label}}</span>
                </div>
                }
                @case ('money-range') {
                <div class="filter-option" [sch-filter-trigger]="moneyRange" [anchorTo]="filterMenuContainer"
                    fallbackStrategy="horizontal">
                    <i *ngIf="option.icon" [sch-icon]="option.icon"></i>
                    <span>{{option.label}}</span>
                </div>
                }
                @case ('number-range') {
                <div class="filter-option" [sch-filter-trigger]="numberRange" [anchorTo]="filterMenuContainer"
                    fallbackStrategy="horizontal">
                    <i *ngIf="option.icon" [sch-icon]="option.icon"></i>
                    <span>{{option.label}}</span>
                </div>
                }
                @case ('multi-select') {
                <div class="filter-option" [sch-filter-trigger]="multiSelect" [anchorTo]="filterMenuContainer"
                    fallbackStrategy="horizontal">
                    <i *ngIf="option.icon" [sch-icon]="option.icon"></i>
                    <span>{{option.label}}</span>
                </div>
                }
                @case ('single-select') {
                <div class="filter-option" [sch-filter-trigger]="select" [anchorTo]="filterMenuContainer"
                    fallbackStrategy="horizontal">
                    <i *ngIf="option.icon" [sch-icon]="option.icon"></i>
                    <span>{{option.label}}</span>
                </div>
                }
                @case ('free-text') {
                <div class="filter-option" [sch-filter-trigger]="freeText" [anchorTo]="filterMenuContainer"
                    fallbackStrategy="horizontal">
                    <i *ngIf="option.icon" [sch-icon]="option.icon"></i>
                    <span>{{option.label}}</span>
                </div>
                }
                @default {

                }
                }

            </ng-container>

        </div>
    </div>
</ng-template>

<ng-template #dateRange>
    <div class="option-type">
        <div class="date-range">
            <seech-date label="Start Date" />
            <seech-date label="End Date" />
        </div>

        <button sch-button>Apply</button>
    </div>
</ng-template>

<ng-template #moneyRange>
    <div class="option-type">
        Money Range
    </div>
</ng-template>

<ng-template #select>
    <div class="option-type">
        Single Select
    </div>
</ng-template>

<ng-template #multiSelect>
    <div class="option-type">
        Multi Select
    </div>
</ng-template>

<ng-template #numberRange>
    <div class="option-type">
        Number Range
    </div>
</ng-template>

<ng-template #freeText>
    <div class="option-type">
        Free Text
    </div>
</ng-template>